import React, {useEffect, useRef, useState, memo, useMemo} from "react"
import BodyPart from "./BodyPart";
import BodyPoints from "./BodyPoints";
import examService from "../../../services/ExamService";
import SwitchButton from "../form-element/SwitchButton";
import ConfirmationDialog from "../Popups/ConfirmationDialog";
import ChiefComplaintQuestion from "./ChiefComplaintQuestion";
import {
    mapDataToLocalModal,
    mapVasQuestionToLocalModal,
    extractEnabledBodyLocationsFromLocallyStoredData
} from './services/chief-complaint'
import selectCCGif from "../../../assets/gif/CC/select_CC_point.gif";
import {toast} from "react-toastify";
import SelectCCPointsList from "./SelectCCPointsList";
import CONSTANT from "../../../constants/Constant";
import {saveNoCC_Complaint} from "../chatbotNew/ChatServices";
import {getArrayFromObject} from "../../../utils/Utils";
import AlertModal from "../AlertModal";
import GLOBAL from "../../../global";

const ChiefComplaint = ({
                            testId,
                            onSubmit,
                            onChange,
                            isReportAvailable = false,
                            ccQuestion = {},
                            updateAnswer,
                            isSavingNoCC,
                            onCCCountChange,
                            isAlreadyCCQuestionAnswered = false
                        }) => {
    const [vasQuestion, setVasQuestion] = useState({})
    const [loading, setLoading] = useState(true)
    const [isShowConfirmation, setIsShowConfirmation] = useState(false)
    const [showQuestionModal, setShowQuestionModal] = useState(false)
    const [showFront, setShowFront] = useState(false);
    const [isLoadingCCAgain, setIsLoadingCCAgain] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    const selectedBodyLocationRef = useRef({});
    const enabledBodyPoints = useRef([]);
    const selectedCCQuestionAnswer = useRef({});//For Yes, Chief Complaint | No, Chief complaint question
    const conformationAlertContentRef = useRef({});

    useEffect(() => {
        if (isSavingNoCC) {
            return
        }

        (async () => {
            fetchAndMapDate();
        })()

        //isSavingNoCC is a flag if user select No, Chief Complaint from confirmation dialog
    }, [isSavingNoCC])

    useEffect(() => {
        const count = Object.keys(vasQuestion).length;
        onCCCountChange && onCCCountChange(count);
        GLOBAL.ISANYCHIEFCOMPLAINTANSWEDED = count > 0;
    }, [vasQuestion, onCCCountChange]);

    const fetchAndMapDate = async () => {
        const data = await fetchData();
        if (data && data instanceof Array && data.length > 0) {
            const mappedData = mapDataToLocalModal(data)
            const formatedVasQuestions = mapVasQuestionToLocalModal(mappedData)
            setVasQuestion(formatedVasQuestions)
            enabledBodyPoints.current = extractEnabledBodyLocationsFromLocallyStoredData(mappedData)
        }
    }

    const fetchData = async () => {
        const response = await examService.getEnabledBodyLocationAndAnsweredVasQuestion({TestId: testId});
        const {data, success, error} = response;

        if (!success) {
            console.error(error);
            return;
        }
        setLoading(false)
        return [...data];
    }

    const vasQuestionHandler = (event) => {
        if (event.target.tagName === 'circle') {
            setIsShowConfirmation(true);
            conformationAlertContentRef.current.yesBtnText = "Confirm";
            conformationAlertContentRef.current.noBtnText = "Cancel";
            conformationAlertContentRef.current.text = `<div>Are the body regions (<strong>${event.target?.dataset?.locationname}</strong>) correctly articulated?</>`;
            conformationAlertContentRef.current.onClickYes = onConfirmHandler;
            conformationAlertContentRef.current.headerText = '';
            selectedBodyLocationRef.current = {
                bodyLocation: event.target.id,
                name: event.target?.dataset?.locationname,
                side: event.target?.dataset?.side
            }
        }
    }

    const onConfirmHandler = () => {
        setShowQuestionModal(true)
        setIsShowConfirmation(false)
    }

    const closeConfirmationModal = () => {
        setIsShowConfirmation(false)
        selectedBodyLocationRef.current = {}
    }

    const handleToggle = () => {
        setShowFront(prevState => !prevState);
    };

    const handleClearALLCCPoints = async (e) => {
        e.preventDefault();

        if (getArrayFromObject(vasQuestion).length <= 0) {
            toast.error('Select at least one cc point');
            return;
        }

        setIsShowConfirmation(true);
        conformationAlertContentRef.current.text = `Are you sure you want to clear all your Chief Complaints?`;
        conformationAlertContentRef.current.onClickYes = () => clearALLCCPoints(getArrayFromObject(vasQuestion));
        conformationAlertContentRef.current.headerText = 'Alert!';
    }

    const clearALLCCPoints = async (points) => {
        if (points.length <= 0) {
            toast.error('Select at least one cc point');
            return;
        }

        let allPoints = points.map(point => point?.bodyLocation);


        let payload = {
            TestId: testId,
            BodyPoints: allPoints
        }

        setIsDeleting(true)
        const response = await examService.clearCCQuestionOfAPoint(payload);
        const {data, success, error} = response;
        setIsDeleting(false)

        if (!success) {
            console.error(error);
            toast.error("Internal Server Error. Please try again")
            return;
        }

        const ChiefComplaintsQuestionStatus = data?.ChiefComplaintsQuestionStatus;
        updateAnswer && ChiefComplaintsQuestionStatus && updateAnswer(ChiefComplaintsQuestionStatus?.AnswerId, ChiefComplaintsQuestionStatus?.AnswerValue);

        setVasQuestion(prevState => {
            let newState = {...prevState}
            allPoints.forEach((point) => {
                delete newState[point]
            })
            if (Object.keys(newState).length === 0) {
                GLOBAL.ISANYCHIEFCOMPLAINTANSWEDED = false;
            }
            return newState;
        });

        setIsShowConfirmation(false);
    }

    const clearACCPoint = async (point) => {
        if (!point?.bodyLocation) {
            toast.error("Please provide body location value");
            return;
        }

        let payload = {
            TestId: testId,
            BodyPoints: [point?.bodyLocation]
        }

        const response = await examService.clearCCQuestionOfAPoint(payload);
        const {data, success, error} = response;

        if (!success) {
            console.error(error);
            toast.error("Internal Server Error. Please try again")
            return;
        }

        const ChiefComplaintsQuestionStatus = data?.ChiefComplaintsQuestionStatus;
        updateAnswer && ChiefComplaintsQuestionStatus && updateAnswer(ChiefComplaintsQuestionStatus?.AnswerId, ChiefComplaintsQuestionStatus?.AnswerValue);

        setVasQuestion(prevState => {
            let newState = {...prevState}
            delete newState[point?.bodyLocation]
            if (Object.keys(newState).length === 0) {
                GLOBAL.ISANYCHIEFCOMPLAINTANSWEDED = false;
            }
            return newState;
        });
    }

    const onChangeCCQuestion = (event) => {
        selectedCCQuestionAnswer.current = event;

        conformationAlertContentRef.current.yesBtnText = "Save";
        conformationAlertContentRef.current.noBtnText = "Cancel";
        conformationAlertContentRef.current.text = `Are you sure you want to save the change?`;
        conformationAlertContentRef.current.onClickYes = handleCCQuestionAnsChange;
        conformationAlertContentRef.current.headerText = '';
        setIsShowConfirmation(true);
    }

    const handleCCQuestionAnsChange = async () => {
        setIsLoadingCCAgain(true);
        await onChange({...selectedCCQuestionAnswer.current, waitUntilSave: true});
        if (selectedCCQuestionAnswer.current?.answerText.toString().toLowerCase().includes('no')) {
            await saveNoCC_Complaint(testId);
            await fetchAndMapDate();
        }
        setIsShowConfirmation(false);
        setIsLoadingCCAgain(false);
    }

    const handleSaveAndClose = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        onSubmit && onSubmit();
    };

    return (
        <>
            {loading ? <div className="chief-complaint__loading-spinner center-element"/> :
                <div className='chief-complaint__main-container height-inherite no-padding-left'>
                    <div
                        className='chief-complaint__body-container chief-complaint-body-container'>
                        {/* Only visible at mobile screen */}
                        <div className="chief-complaint__body-wrapper">
                            <div className="chief-complaint__svg-container w-100-percent svg-container">
                                <div className='body-toggle-btn-container'>
                                    <SwitchButton onChangeHandler={handleToggle} isChecked={showFront}/>
                                </div>
                                <BodyPart
                                    imageSide={CONSTANT.SIDE.FRONT.name}
                                    styleName='male_front'
                                    showFirst={!showFront}
                                    imageLink='https://mmhva.blob.core.windows.net/vaportal/chief-complaint/front-img.png'
                                    vasQuestionHandler={vasQuestionHandler}
                                    pointListComponent={
                                        <SelectCCPointsList
                                            vasQuestion={vasQuestion}
                                            side={CONSTANT.SIDE.FRONT.name}
                                            clearACCPoint={clearACCPoint}
                                            clearALLCCPoints={clearALLCCPoints}
                                            isReportAvailable={isReportAvailable}
                                            selectedBodyLocationRef={selectedBodyLocationRef}
                                            setShowQuestionModal={setShowQuestionModal}
                                        />
                                    }
                                >
                                    <BodyPoints
                                        points={enabledBodyPoints.current}
                                        answeredVasQuestion={vasQuestion}
                                        side={1}
                                    />
                                </BodyPart>
                                <BodyPart
                                    imageSide={CONSTANT.SIDE.BACK.name}
                                    styleName='male_back'
                                    showFirst={showFront}
                                    imageLink='https://mmhva.blob.core.windows.net/vaportal/chief-complaint/backimage.png'
                                    vasQuestionHandler={vasQuestionHandler}
                                    pointListComponent={
                                        <SelectCCPointsList
                                            vasQuestion={vasQuestion}
                                            side={CONSTANT.SIDE.BACK.name}
                                            clearACCPoint={clearACCPoint}
                                            clearALLCCPoints={clearALLCCPoints}
                                            isReportAvailable={isReportAvailable}
                                            selectedBodyLocationRef={selectedBodyLocationRef}
                                            setShowQuestionModal={setShowQuestionModal}
                                        />
                                    }
                                >
                                    <BodyPoints
                                        points={enabledBodyPoints.current}
                                        answeredVasQuestion={vasQuestion}
                                        side={2}
                                    />
                                </BodyPart>
                            </div>

                            {getArrayFromObject(vasQuestion).length > 1 && (
                                <div className="w-100-percent chief-complaint__clear-container">
                                    <button
                                        className="bg-color-ice-blue-4 body-point-text__clear chief-complaint__clear-button w-full"
                                        onClick={async (e) => {
                                            e.preventDefault();
                                            await handleClearALLCCPoints(e);
                                        }}
                                        disabled={isReportAvailable}
                                    >
                                        Clear All Key Points
                                        {(isDeleting) ?
                                            <i className="fa fa-spinner fa-spin chief-complaint__spinner-icon"/> : ""}
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                    <div
                        className="chief-complaint__info-container body-part chief-complaint-info-container">
                        <p className="body-part-click-instruction chief-complaint__instruction-text">
                            {(
                                // From EditAssessment
                                ccQuestion?.questionTitle && !onSubmit)
                                ? (
                                    <div>
                                        <p>
                                            {!isReportAvailable
                                                ? "To resume the biometric, click 'Resume Biometric'. To close it, click (X)."
                                                : "Thank you for completing the assessment. To close this tab, click the (X) button."
                                            }
                                        </p>
                                        <img alt="cc_point" src={selectCCGif}
                                             className="w-60-percent object-fit-scale-down "/>
                                        <p className="chief-complaint__instruction-subtext">To mention chief complaint,
                                            please select flashing key points.</p>
                                    </div>
                                )
                                // From Chatbot
                                :
                                <div>
                                    <img alt="cc_point" src={selectCCGif}
                                         className="w-60-percent object-fit-scale-down"/>
                                    <p className="chief-complaint__instruction-subtext">Let's continue with your chief
                                        complaint. Please select a Blue highlighted area of the body that bothers you on
                                        a daily or intermittent basis. When you are done please click save and close
                                        from button.</p>
                                </div>

                            }
                        </p>
                        {/* If you use came from chatbot in cc only then this btn will be shown */}
                        {onSubmit &&
                            <button
                                className="button rounded-btn ok-btn chief-complaint__submit-button font-size-md"
                                onClick={handleSaveAndClose}>Save
                                & Close</button>
                        }
                    </div>
                </div>
            }

            {isShowConfirmation && (
                <AlertModal
                    show={isShowConfirmation}
                    title="Confirmation"
                    type="warning"
                    onConfirm={conformationAlertContentRef.current?.onClickYes}
                    onClose={closeConfirmationModal}
                    onCancel={closeConfirmationModal}
                    confirmBtnText={conformationAlertContentRef.current?.yesBtnText || "Yes"}
                    cancelBtnText={conformationAlertContentRef.current?.noBtnText || "No"}
                    showCancel={true}
                    showCloseButton={true}
                >
                    <div
                        dangerouslySetInnerHTML={{
                            __html: conformationAlertContentRef.current?.text || "",
                        }}
                    />
                </AlertModal>

            )}

            {showQuestionModal &&
                <ChiefComplaintQuestion
                    locationName={selectedBodyLocationRef.current?.name}
                    bodyLocation={selectedBodyLocationRef.current?.bodyLocation}
                    side={selectedBodyLocationRef.current?.side}
                    vasQestionHandler={setVasQuestion}
                    testId={testId}
                    closeModal={setShowQuestionModal}
                    onSubmit={onSubmit}
                    isReportAvailable={isReportAvailable}
                    updateAnswer={updateAnswer}
                    ccQuestion={ccQuestion}
                />}
        </>
    )
}

export default ChiefComplaint;
